import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';

@Component({
  selector: 'common-environment-header',
  templateUrl: './environment-header.component.html',
  styleUrls: ['./environment-header.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class EnvironmentHeaderComponent {
  environment = input.required<string>();
  applicationVersion = input.required<string | undefined>();
  environmentHeaderDismissed = output<void>();

  get environmentNameVersion() {
    return this.applicationVersion()
      ? `${this.environment()} - ${this.applicationVersion() || '?'}`
      : this.environment();
  }

  dismiss() {
    this.environmentHeaderDismissed.emit();
  }
}
